import {Link} from 'react-router-dom';
import React from 'react';

import {useracc, postApi, putApi, deleteApi, getCookie, setCookie} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
import PaymentModule from '../payment/payment';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';


export default class Accountcart extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      order: {},
      coupon: {
        status: false,
        message: '',
      },
      payment: {
        status: false,
        message: '',
      },
    }
    this.getCart = this.getCart.bind(this);
    this.applyCoupon = this.applyCoupon.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.makePayment = this.makePayment.bind(this);
  }

  async componentDidMount() {
    const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
    await this.getCart();
  }

  async getCart() {

    let params = new URLSearchParams();
    let order = await getCookie('order');
		if( order.length > 0 ) {
			params.append('order', order[0].product);
			params.append('period', order[0].period);
		}
    const x = await postApi('/v3/account/cart', params);
    if( x.data.order && !x.data.order.receipt ) x.data.order.receipt = '0';
    this.setState({status: true, order: x.data.order ? x.data.order : {}});
  }

  async applyCoupon(event) {
    if( event ) event.preventDefault();
    const _coupon = document.getElementById("coupon").value;
    if( _coupon.length === 0 ) return;

    let order = this.state.order;
    let coupon = this.state.coupon;
    coupon.status = true;

    this.setState({coupon}, async ()=>{
      let params = new URLSearchParams();
      let _order = await getCookie('order');
      if( _order.length > 0 ) {
        params.append('order', _order[0].product);
        params.append('period', _order[0].period);
      }
      params.append('coupon', _coupon);
      const x = await putApi('/v3/account/coupon', params);
      if( x.status === 200 ) {
        coupon.status = x.status;
        coupon.message = "Coupon added.";
        order = x.data.order;
        if( !order.receipt ) order.receipt = '0';
      } else if( x.status > 200 ) {
        coupon.status = x.status;
        coupon.message = x.data;
      }
      this.setState({order, coupon});
    });
  }


  async removeItem() {
    let params = new URLSearchParams();
    let order = await getCookie('order');
		if( order.length > 0 ) {
			params.append('order', order[0].product);
			params.append('period', order[0].period);
		}
    let x = await deleteApi('/v3/account/cart', params);
    x = null;
    await setCookie('order', []);
    this.setState({order: {}, coupon: {
      status: false,
      message: '',
    }});
  }


  async makePayment(method, payment) {
    let order = await getCookie('order');
    let params = new URLSearchParams();
    params.append("method", method);
    params.append("payment", payment);
		if( order.length > 0 ) {
			params.append('order', order[0].product);
			params.append('period', order[0].period);
		}
		let x = await putApi('/v3/account/order', params);
    console.log(x.data);
    if( x.status === 200 ) {
      
      this.setState({order: x.data.order});
      return {};
    } else {
      return x.data;
    }
  }

  render() {
    console.log(this.state.order);
		return (
      <>
        <div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
          <h4 className="fw-medium mb-0">Checkout</h4>
          <div className="ms-sm-1 ms-0">
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Checkout</li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="main-content app-content">
          <div className="container-fluid">

            <div className="container">
                        
              <div className="row">
                {Object.keys(this.state.order).length > 0 ?
                  <>
                    <div className="col-xl-9">
                      <div className="card custom-card">
                        <div className="card-body p-0 product-checkout">
                          <ul className="nav nav-tabs tab-style-6 nav-justified d-sm-flex d-block border-bottom border-block-end-dashed" id="myTab1" role="tablist">
                            <li className="nav-item" role="presentation">
                              <button className={`nav-link ${this.state.order.receipt==='0'?'active':''}`} id="shipped-tab" data-bs-toggle="tab" data-bs-target="#shipped-tab-pane" type="button" role="tab" aria-controls="shipped-tab" aria-selected={this.state.order.receipt!=='0'?true:false}><i className="ri-bank-card-line me-2 align-middle d-inline-block"></i>Payment</button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button className={`nav-link ${this.state.order.receipt!=='0'?'active':''}`} id="delivered-tab" data-bs-toggle="tab" data-bs-target="#delivery-tab-pane" type="button" role="tab" aria-controls="delivered-tab" aria-selected={this.state.order.receipt!=='0'?true:false} tabIndex="-1"><i className="ri-checkbox-circle-line me-2 align-middle d-inline-block"></i>Confirmation</button>
                            </li>
                          </ul>
                          <div className="tab-content" id="myTabContent">
                            <div className={`tab-pane fade border-0 p-0 ${this.state.order.receipt==='0'?'active show':''}`} id="shipped-tab-pane" role="tabpanel" aria-labelledby="shipped-tab-pane" tabIndex="0">
                              <div className="p-4">
                                <div className="fs-15 fw-semibold d-sm-flex d-block align-items-center justify-content-between mb-3">
                                  <div>Coupon Code :</div>
                                </div>
                                <div className="row">
                                  <div className="col-xl-12 pb-4">
                                    <form onSubmit={(e)=>this.applyCoupon(e)}>
                                      <div className="input-group">
                                        <input type="text" id="coupon" className="form-control form-control-sm" placeholder="Coupon Code" aria-label="coupon-code" aria-describedby="coupons" />
                                        <button type="button" className="btn btn-primary input-group-text" id="coupons" onClick={()=>this.applyCoupon()} disabled={this.state.coupon.status===true}>Apply</button>
                                      </div>
                                    </form>
                                    {this.state.coupon.status === 200 &&
                                      <span className="badge rounded-pill bg-success">{this.state.coupon.message}</span>
                                    }
                                    {this.state.coupon.status > 200 &&
                                      <span className="badge rounded-pill bg-danger">{this.state.coupon.message}</span>
                                    }
                                  </div>
                                  <div className="col-xl-12 pb-4">
                                    <div className="fs-15 fw-semibold d-sm-flex d-block align-items-center justify-content-between mb-3">
                                      <div>Order Summary :</div>
                                    </div>
                                    <ul className="list-group mb-0 border-0 rounded-0">
                                      <li className="list-group-item  border-bottom border-block-end-dashed">
                                        <div className="d-flex align-items-start flex-wrap">
                                          <div className="me-2">
                                            <span className="avatar avatar-xxl bd-gray-200">
                                              <img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/3.png" alt="" />
                                            </span>
                                          </div>
                                          <div className="flex-fill">
                                            <p className="mb-0 fw-semibold  fs-15">{this.state.order.product} - {this.state.order.quote}</p>
                                            <p className="mb-0 fs-14 fw-semibold">£{this.state.order.price.toFixed(2)} <span className="text-muted">/ {this.state.order.period===1?'Month':'Year'}</span></p>
                                            
                                          </div>
                                          <div>
                                            <p className="mb-0 text-end">
                                              <a aria-label="anchor" href="javascript:void(0)">
                                                <i className="ri-close-line fs-15 text-danger bg-danger-transparent rounded-1"></i>
                                                <Button size="sm" variant="danger" onClick={()=>this.removeItem()}><FontAwesomeIcon icon="trash" /></Button>
                                              </a>
                                            </p>
                                          </div>
                                        </div>
                                      </li>

                                    </ul>
                                  </div>

                                  <div className="col-xl-12">
                                    <div className="card custom-card border shadow-none mb-3">
                                      <div className="card-header">
                                        <div className="card-title">
                                          Payment Methods
                                        </div>
                                      </div>
                                      <div className="card-body">
                                        <PaymentModule order={1} makePayment={this.makePayment} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*<div className="px-4 py-3 border-top border-block-start-dashed d-sm-flex justify-content-between">
                                <span className="d-inline-flex"></span>
                                <button type="button" className="btn btn-success mt-sm-0 mt-2" id="continue-payment-trigger">Place Order<i className="bi bi-credit-card-2-front align-middle ms-2"></i></button>
                              </div>*/}
                            </div>
                            <div className={`tab-pane  border-0 p-0 ${this.state.order.receipt!=='0'?'active':''}`} id="delivery-tab-pane" role="tabpanel" aria-labelledby="delivery-tab-pane" tabIndex="0">
                              <div className="p-5 checkout-payment-success my-3">
                                <div className="mb-5">
                                  <h5 className="text-success fw-semibold">Payment Successful... 😊</h5>
                                </div>
                                <div className="mb-5">
                                  <img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/24.png" alt="" />
                                </div>
                                <div className="mb-4">
                                  <p className="mb-1 fs-14">Thank you for shopping with us.</p>
                                  <p className="text-muted">Transaction ID: {this.state.order.receipt}</p>
                                </div>
                                {/*<a href="https://laravelui.spruko.com/velvet/products" className="btn btn-success">Continue Shopping<i className="bi bi-cart ms-2"></i></a>*/}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="card custom-card">
                        <div className="card-header">
                          <div className="card-title me-1">Order Details</div><span className="badge bg-success-transparent rounded-pill">03</span>
                        </div>
                        <div className="card-body p-0">
                          <div className="p-3 border-bottom border-block-end-dashed">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <div className="fw-semibold fs-14">Product</div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <div className="text-muted fs-15"> {this.state.order.product}</div>
                              <div className="fw-semibold fs-15n ">£{this.state.order.price.toFixed(2)} <span className="text-muted">/ {this.state.order.period===1?'Month':'Year'}</span></div>
                            </div>
                          </div>
                          {this.state.order?.coupons.length > 0 &&
                            <div className="p-3 border-bottom border-block-end-dashed">
                              <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <div className="fs-12 fw-semibold p-2 rounded"></div>
                                <div className="text-success">COUPON APPLIED</div>
                              </div>
                            </div>
                          }
                          <div className="p-3 border-bottom border-block-end-dashed">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <div className="text-muted op-7">Sub Total</div>
                              <div className="fw-semibold fs-14">£{this.state.order.price.toFixed(2)} <span className="text-muted">/ {this.state.order.period===1?'Month':'Year'}</span></div>
                            </div>
                            {this.state.order?.coupons.length > 0 &&
                              <>
                                {this.state.order.coupons.map((e, i)=>{
                                  return (
                                    <div key={i} className="d-flex align-items-center justify-content-between mb-3">
                                      <div className="text-muted op-7">{e.code}</div>
                                      <div className="fw-semibold fs-14 text-success">{e.discount_percent?`${e.discount_percent}%`:''}{e.discount_fixed?`£${e.discount_fixed}`:''}</div>
                                    </div>
                                  )
                                })}
                              </>
                            }
                            {/*<div className="d-flex align-items-center justify-content-between">
                              <div className="text-muted op-7">Service Tax (18%)</div>
                              <div className="fw-semibold fs-14">- $45.29</div>
                            </div>*/}
                          </div>
                          {this.state.order?.coupons.length > 0 &&
                            <div className="p-2 m-2 bg-success-transparent">
                              <div className="d-flex  justify-content-between  align-items-center">
                                <p className="fs-12 mb-0 text-success">Your total savings amount</p>
                                <div className="fw-semibold fs-16 text-Success"> £{(this.state.order.price-this.state.order.total).toFixed(2)}</div>
                              </div>
                            </div>
                          }
                          <div className="p-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="fs-15">Total :</div>
                              <div className="fw-semibold fs-16 text-dark"> £{this.state.order.total.toFixed(2)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                :
                  <>
                    <div className="col-xl-9">
                      <div className="card custom-card">
                        <div className="card-body p-0 product-checkout">
                          <ul className="nav nav-tabs tab-style-6 nav-justified d-sm-flex d-block border-bottom border-block-end-dashed" id="myTab1" role="tablist">
                            <li className="nav-item" role="presentation">
                              <button className="nav-link active" disabled={true} id="shipped-tab" data-bs-toggle="tab" data-bs-target="#shipped-tab-pane" type="button" role="tab" aria-controls="shipped-tab" aria-selected="true"><i className="ri-bank-card-line me-2 align-middle d-inline-block"></i>Payment</button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button className="nav-link" disabled={true} id="delivered-tab" data-bs-toggle="tab" data-bs-target="#delivery-tab-pane" type="button" role="tab" aria-controls="delivered-tab" aria-selected="false" tabIndex="-1"><i className="ri-checkbox-circle-line me-2 align-middle d-inline-block"></i>Confirmation</button>
                            </li>
                          </ul>
                          <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade border-0 p-0 active show" id="shipped-tab-pane" role="tabpanel" aria-labelledby="shipped-tab-pane" tabIndex="0">
                              <div className="p-4">
                                <div className="fs-15 fw-semibold d-sm-flex d-block align-items-center justify-content-between mb-3">
                                  <div>No orders</div>
                                </div>
                                <div className="row">

                                </div>
                              </div>
                              <div className="px-4 py-3 border-top border-block-start-dashed d-sm-flex justify-content-between">
                                <span className="d-inline-flex"></span>
                                <button type="button" className="btn btn-success mt-sm-0 mt-2" id="continue-payment-trigger">Place Order<i className="bi bi-credit-card-2-front align-middle ms-2"></i></button>
                              </div>
                            </div>
                            <div className="tab-pane fade border-0 p-0" id="delivery-tab-pane" role="tabpanel" aria-labelledby="delivery-tab-pane" tabIndex="0">
                              <div className="p-5 checkout-payment-success my-3">
                                <div className="mb-5">
                                  <h5 className="text-success fw-semibold">Payment Successful... 😊</h5>
                                </div>
                                <div className="mb-5">
                                  <img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/24.png" alt="" />
                                </div>
                                <div className="mb-4">
                                  <p className="mb-1 fs-14">You can track your order with Order Id <b>SPK#1FR</b> from <a className="link-success" href="javascript:void(0);"><u>Track Order</u></a></p>
                                  <p className="text-muted">Thankyou for shopping with us.</p>
                                </div>
                                <a href="https://laravelui.spruko.com/velvet/products" className="btn btn-success">Continue Shopping<i className="bi bi-cart ms-2"></i></a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="card custom-card">
                        <div className="card-header">
                          <div className="card-title me-1">Order Details</div>
                        </div>
                        <div className="card-body p-0">
                            
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}